function activateDatePicker() {
  $("#date").datepicker({
    format: "yyyy/mm/dd",
    startDate: "+4d",
    endDate: "+13d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on('changeDate', function(e){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          date: $("#date").val()
        }
      })
    })
    $("#date_drawer").val($("#date").val())
  });
  $("#date").datepicker("update", $("#date").data("delivery_date"));
}

function activateDrawerDatePicker() {
  $("#date_drawer").datepicker({
    format: "yyyy/mm/dd",
    startDate: "+4d",
    endDate: "+13d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on('changeDate', function(e){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          date: $("#date_drawer").val()
        }
      })
    })
    $("#date").val($("#date_drawer").val())
  });
  $("#date_drawer").datepicker("update", $("#date_drawer").data("delivery_date"));
}

$(document).ready(function() {
  activateDatePicker()
  activateDrawerDatePicker()

  // 監視する対象の要素
  const targetNode = document.getElementById('CartDrawer');
  
  // オプション（子ノードの追加を監視）
  const config = { childList: true, subtree: true };
  
  // MutationObserverを作成
  const observer = new MutationObserver(function(mutationsList) {
    for(let mutation of mutationsList) {
      if (mutation.target.classList.contains('drawer__footer')) {
        activateDrawerDatePicker();
      }
    }
  });
  
  // 監視を開始
  observer.observe(targetNode, config);
});